import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../../Components/Form";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import {
    CadastrarFormularioProdutoController,
    ListarEmpreendimentosController,
} from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import {
    ICadastrarFormularioProduto,
    IEmpreendimento,
} from "../../../../../Interfaces/Geral/Produtos/ProdutosInterface";

interface ICadastrarFormularioProdutoProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    listarEmpreendimentos: (...args: any[]) => Promise<IEmpreendimento[]>;
}

export default function CadastrarFormularioProduto(
    props: ICadastrarFormularioProdutoProps
) {
    const {
        execute: CadastrarFormularioProduto,
        loading: CadastrarFormularioProdutoLoading,
    } = useAsyncCallback(CadastrarFormularioProdutoController);

    function handleCadastrarFormProduto(formData: ICadastrarFormularioProduto) {
        CadastrarFormularioProduto({
            ...formData,
            DS_DESCRICAO: formData.DS_DESCRICAO,
            DS_FORMULARIO: formData.DS_FORMULARIO,
            ID_PRODUTO: formData.ID_PRODUTO,
        }).then(() => {
            props.setShow(false);
            props.listarEmpreendimentos();
        });
    }

    return (
        <UnForm handleSubmit={handleCadastrarFormProduto}>
            <div className="mb-8">
                <div className="row m-0 d-flex justify-content-center ">
                    <UnForm.Input
                        name="DS_FORMULARIO"
                        label="Nome do Formulário"
                        registerOptions={{
                            required: "Insira o Nome do Formulário",
                        }}
                        wrapperClassName="col-12 col-md-12 m-0"
                    />
                </div>
            </div>

            <div className="mb-8">
                <div className="row m-0 ">
                    <UnForm.Textarea
                        registerOptions={{
                            required: "Insira a Descrição do Formulário",
                        }}
                        name="DS_DESCRICAO"
                        label="Descrição do Formulário"
                        noRezise
                        rows={3}
                        wrapperClassName="col-12 col-md-12 m-0"
                    />
                </div>
            </div>

            <div className="mb-8">
                <div className="row m-0 ">
                    <UnForm.LazySelect
                        registerOptions={{
                            required: "Selecione uma opção",
                        }}
                        controller={ListarEmpreendimentosController}
                        getDS={(s) => s.DS_EMPREENDIMENTO}
                        getKeyValue={(s) => s.ID_EMPREENDIMENTO}
                        name="ID_PRODUTO"
                        label="Produto"
                        wrapperClassName="col-12 col-md-12 m-0"
                    />
                </div>
            </div>

            <UnForm.SubmitButton
                color="success"
                wrapperClassName="w-100 mt-8 col-12"
                className="w-100"
                icon={faPlus}
                loading={CadastrarFormularioProdutoLoading}
                disabled={CadastrarFormularioProdutoLoading}
                loadingSize={"sm"}
            >
                Cadastrar Formulário
            </UnForm.SubmitButton>
        </UnForm>
    );
}
